/**
 * separated分组标识
 */
export const GROUPS = {
  separated: "Separated",
};

/**
* Accumulated筛选器默认值
*/
export const ACCUMULATED_DEFAULT_VALUE = 'accumulated';

/**
* Accumulated选项组配置
*/
export const ACCUMULATED_OPTIONS = [{
  value: ACCUMULATED_DEFAULT_VALUE,
  text: 'Accumulated',
}];

/**
* Separated选项组配置
*/
export const SEPARATED_OPTIONS = [
  {
    groupKey: 'separated',
    value: 'zone',
    text: 'By Zone',
  },
  {
    groupKey: 'separated',
    value: 'region',
    text: 'By Region',
  },
  {
    groupKey: 'separated',
    value: 'country',
    text: 'By Country',
  },
  {
    groupKey: 'separated',
    value: 'system',
    text: 'By System',
  },
  {
    groupKey: 'separated',
    value: 'channel',
    text: 'By Channel',
  },
  {
    groupKey: 'separated',
    value: 'language',
    text: 'By Language',
  },
  {
    groupKey: 'separated',
    value: 'bundle',
    text: 'By Bundle',
  },
  {
    groupKey: 'separated',
    value: 'ua_network',
    text: 'By Media Channel',
  },
  {
    groupKey: 'separated',
    value: 'version',
    text: 'By Version',
  },
  {
    groupKey: 'separated',
    value: 'campaign',
    text: 'By Campaign',
  }
];


export const GROUP_BY_INDEX = {
  zone: 0,
  region: 1,
  country: 2,
  system: 3,
  channel: 4,
  language: 5,
  churn_level: 6,
};



